<nav id="sidebar" class="active">
  <div class="sidebar-wrapper active sidenavstyle">
    <div class="sidebar-menu">
      <ul class="menu">
        <!-- <li class="sidebar-title">Menu</li> -->
        <!-- Link to Project Dashboard -->
        <li routerLinkActive="active" class="sidebar-item">
          <a id="nav-dashboard" routerLink="dashboard" class='sidebar-link'>
            <img class="nav-icon" src="assets/icons/list_alt_black_24dp.svg">
            <span>{{'sideNavigation.titleDashboard' | translate }}</span>
          </a>
        </li>

        <!-- Link to Schedule -->
        <!-- Disabled temporary, needs fixing. Does not work well with inverter + string/frame project. Only supports one of kind project.
        <li routerLinkActive="active" class="sidebar-item">
          <a id="project-schedule" routerLink="schedule" class='sidebar-link'>
            <img class="nav-icon" src="assets/icons/calendar_available_black_24dp.svg">
            <span>{{'basic.schedule' | translate }}</span>
          </a>
        </li>
        -->

        <!-- Link to Settings -->
        <li routerLinkActive="active" class="sidebar-item">
          <a id="project-settings" routerLink="project" class='sidebar-link'>
            <img class="nav-icon" src="assets/icons/settings-wheel.svg">
            <span>{{'basic.settings' | translate }}</span>
          </a>
        </li>

        <!-- Link to Weekly Planning -->
        <li routerLinkActive="active" class="sidebar-item">
          <a id="weekly-planning" routerLink="weekly-planning" class='sidebar-link'>
            <img class="nav-icon" src="assets/icons/calendar_available_black_24dp.svg">
            <span>{{'sideNavigation.titleWeeklyPlanning' | translate }}</span>
          </a>
        </li>

        <!-- Link to Route Planning -->
        @if (customerId === customerIds.POWERLINES) {
          <li
            routerLinkActive="active"
            class="sidebar-item">
            <a id="rouite-planning" routerLink="route-planning" class='sidebar-link'>
              <img class="nav-icon" src="assets/icons/route_planner.svg">
              <span>{{'sideNavigation.titleRoutePlanning' | translate }}</span>
            </a>
          </li>
        }

        <!-- Human Resources submenu (powerlines only) -->
        @if (customerId === customerIds.POWERLINES) {
          <li class="sidebar-item has-sub">
            <a routerLink="human-resources" class='sidebar-link' (click)="toggleSubmenu($event, 'humanResourcesSubmenu')">
              <img class="nav-icon" src="assets/icons/groups_black_24dp.svg">
              <span>{{'basic.humanResources' | translate }}</span>
            </a>
            <ul id="humanResourcesSubmenu" class="submenu" [style.display]="humanResourcesOpen ? 'block' : 'none'">
              <li routerLinkActive="active" class="submenu-item">
                <a routerLink="workers">{{'sideNavigation.titleWorkers' | translate }}</a>
              </li>
              <li routerLinkActive="active" class="submenu-item">
                <a routerLink="teams">{{'basic.teams' | translate }}</a>
              </li>
              <li routerLinkActive="active" class="submenu-item">
                <a routerLink="planner-management">{{'sideNavigation.titlePlanners' | translate }}</a>
              </li>
            </ul>
          </li>
        }

        <!-- Standalone Workers and Teams links (non-powerlines) -->
        @if (customerId !== customerIds.POWERLINES) {
          <li routerLinkActive="active" class="sidebar-item">
            <a routerLink="workers" class='sidebar-link'>
              <img class="nav-icon" src="assets/icons/person_black_24dp.svg">
              <span>{{'sideNavigation.titleWorkers' | translate }}</span>
            </a>
          </li>
          <li routerLinkActive="active" class="sidebar-item">
            <a routerLink="teams" class='sidebar-link'>
              <img class="nav-icon" src="assets/icons/groups_black_24dp.svg">
              <span>{{'basic.teams' | translate }}</span>
            </a>
          </li>
        }
        <!-- <li class="sidebar-title">Menu</li> -->
      </ul>
    </div>
    <button class="sidebar-toggler btn x"><i data-feather="x"></i></button>
  </div>
</nav>
